"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CloudUpload = _interopRequireDefault(require("@mui/icons-material/CloudUpload"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _components = require("../../../../components");
var _AttachmentsList = _interopRequireDefault(require("./AttachmentsList/AttachmentsList"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SNETImageUploadModule = _interopRequireDefault(require("./SNETImageUpload.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SNETImageUpload = _ref => {
  let {
    attachments,
    setAttachments,
    handleImageChange,
    maxImageSizeMB,
    isMultiple = false
  } = _ref;
  const fileInputRef = (0, _react.useRef)(null);
  const attachmentErrorTimeoutRef = (0, _react.useRef)(undefined);
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [isUploadingAttachments, setIsUploadingAttachments] = (0, _react.useState)(false);
  const [attachmentSizeError, setAttachmentSizeError] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    return () => {
      if (attachmentErrorTimeoutRef.current) {
        clearTimeout(attachmentErrorTimeoutRef.current);
      }
    };
  }, []);
  const handleAttachments = async e => {
    setError();
    const fileList = e.target.files;
    if (!fileList || fileList.length === 0) {
      return;
    }
    const incomingFiles = Array.from(fileList);
    const validFiles = incomingFiles.filter(file => file.size <= maxImageSizeMB * 1024 * 1024);
    if (incomingFiles.length !== validFiles.length) {
      const size = Math.round(maxImageSizeMB);
      setAttachmentSizeError(true);
      setError(`Some files exceed the maximum size of ${size}MB.`);
      if (attachmentErrorTimeoutRef.current) {
        clearTimeout(attachmentErrorTimeoutRef.current);
      }
      attachmentErrorTimeoutRef.current = window.setTimeout(() => {
        setAttachmentSizeError(false);
      }, 2000);
    }
    if (validFiles.length === 0) {
      return;
    }
    setIsUploadingAttachments(true);
    try {
      await Promise.all(validFiles.map(async file => {
        await handleImageChange(file);
      }));
    } catch (e) {
      setError("Failed to upload attachments. Please, try again.");
    } finally {
      setIsUploadingAttachments(false);
      e.target.value = "";
    }
  };
  const handleDragLeave = event => {
    event.preventDefault();
    event.stopPropagation();
    const currentTarget = event.currentTarget;
    const relatedTarget = event.relatedTarget;
    if (!currentTarget.contains(relatedTarget)) {
      setIsDragging(false);
    }
  };
  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    if (!isUploadingAttachments) {
      setIsDragging(true);
    }
  };
  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    if (isUploadingAttachments) {
      return;
    }
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      const dataTransfer = new DataTransfer();
      Array.from(files).forEach(file => {
        dataTransfer.items.add(file);
      });
      const syntheticEvent = {
        target: {
          files: dataTransfer.files
        }
      };
      handleAttachments(syntheticEvent);
    }
  };
  const handleRemoveAttachment = id => {
    setAttachments(prevAttachments => {
      const index = prevAttachments.findIndex(item => item.id === id);
      if (index === -1) {
        return prevAttachments;
      }
      return prevAttachments.filter(item => item.id !== id);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    id: "attachments",
    name: "attachments",
    type: "file",
    multiple: isMultiple,
    accept: "image/png,image/jpg,image/jpeg",
    onChange: handleAttachments,
    style: {
      display: "none"
    },
    ref: fileInputRef
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_SNETImageUploadModule.default.attachments, isUploadingAttachments && _SNETImageUploadModule.default.loading, isDragging && _SNETImageUploadModule.default.dragging),
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    onClick: () => isUploadingAttachments ? {} : fileInputRef.current?.click(),
    disabled: isUploadingAttachments,
    "aria-label": "Upload attachments"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETImageUploadModule.default.attachmentsText
  }, isUploadingAttachments ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    className: _SNETImageUploadModule.default.loader,
    size: "35px"
  }) : /*#__PURE__*/_react.default.createElement(_CloudUpload.default, {
    fontSize: "large"
  }), /*#__PURE__*/_react.default.createElement("h5", null, "Drag and drop files here or ", /*#__PURE__*/_react.default.createElement("span", {
    className: _SNETImageUploadModule.default.accent
  }, "click"), " to upload"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SNETImageUploadModule.default.attachmentsDescription, attachmentSizeError && _SNETImageUploadModule.default.attachmentsDescriptionError)
  }, /*#__PURE__*/_react.default.createElement("p", null, "Image file must have .png, jpg, or jpeg extension."), /*#__PURE__*/_react.default.createElement("p", null, `File must be under ${maxImageSizeMB}mb)`))), isMultiple && attachments.length > 0 && /*#__PURE__*/_react.default.createElement(_AttachmentsList.default, {
    attachments: attachments,
    removeAttachment: handleRemoveAttachment
  }), /*#__PURE__*/_react.default.createElement(_components.AlertBox, {
    type: _components.alertTypes.ERROR,
    message: error
  })));
};
var _default = exports.default = SNETImageUpload;